<template>
    <div>
        <div class="title">
            <p ></p>
            <h4>上传线索材料、保全法院的信息</h4>
        </div>
<!--        ******************************************************线索材料*********************************************************************-->
        <div class="matter">
            <div class="fileContent">
                <p>线索材料:</p>
            </div>
            <el-upload
                    ref='upload'
                    :limit="10"
                    class="inline"
                    :on-preview="handlePreview"
                    :on-remove="(file, fileList) => {applicationRemove(file, fileList)}"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    accept=".pdf,.png,.jpg,.zip,.rar"
                    :headers="headers"
                    :action="url"
                    name="file"
                    :data="upload_data"
                    :file-list="application"
            >
                <el-button class="custom">
                    上传
                </el-button>
            </el-upload>
        </div>
<!--        *********************************************************保全法院的信息*************************************************************-->
        <div class="matter">
            <div class="fileContent">
                <p>保全法院的信息:</p>
            </div>
            <el-upload
                    ref='upload'
                    class="inline"
                    :limit="10"
                    :on-preview="handlePreview"
                    :on-remove="(file, fileList) => {removeFile(file, fileList)}"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    accept=".pdf,.png,.jpg,.zip,.rar"
                    :headers="headers"
                    :action="url"
                    name="file"
                    :data="court_data"
                    :file-list="courtList"
            >
                <el-button class="custom">
                    上传
                </el-button>
            </el-upload>
        </div>
<!--        保存文件-->
        <div class="preserve">
            <el-button @click="saveFileBtn">保存文件</el-button>
        </div>
    </div>
</template>

<script>
    import { saveClueMaterial } from '../../../api/insure';

    export default {
        name: 'clueMaterial',
        props:['showList'],
        data(){
            return{
                url:process.env.VUE_APP_BASE_API+'/api/upload_cailiao_fayuan_file', //上传文件地址
                headers:{
                    "Authorization": sessionStorage.getItem("token")
                },
                //线索材料
                upload_data:{
                    case_id:'',
                    doc_type:'69'
                },
                //保全法院的信息
                court_data:{
                    case_id:'',
                    doc_type:'70'
                },
                clueForm:[],   //线索材料 code
                courtForm:[],  //法院文件 code
                application:[], //线索材料
                courtList:[], //保全法院的信息
            }
        },
        methods:{
            //点击文件列表事件
            handlePreview(file){
                if (file.all_url){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.all_url);
                }else if (file.response){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.response.data.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.response.data.all_url);
                }
            },
            //删除
            applicationRemove(file, fileList){
                let arr = [];
                fileList.forEach(res => {
                    if (!res.response) {
                        arr.push(res.psd_code);
                    } else {
                        arr.push(res.response.data.psd_code);
                    }
                });
                this.clueForm = arr;
            },
            //法院保全信息 删除
            removeFile(file, fileList){
                let arr = [];
                fileList.forEach(res => {
                    if (!res.response) {
                        arr.push(res.psd_code);
                    } else {
                        arr.push(res.response.data.psd_code);
                    }
                });
                this.courtForm = arr;
            },
            //限制上传个数
            handleExceed(files, fileList){
                if (fileList.length>=10){
                    this.$message.error('只能上传10个文件');
                }
            },
            //上传成功
            handleSuccess(response, file, fileList){
                if (response.code==200){
                    if (response.data.doc_type==69){
                        this.clueForm.push(response.data.psd_code)
                    }else if (response.data.doc_type==70){
                        this.courtForm.push(response.data.psd_code)
                    }
                    this.$message.success(response.msg)
                }else {
                    this.$message.error(response.msg)
                }
            },
            //保存文件
            saveFileBtn(){
                let data={
                    case_id:this.$route.query.id,
                    cailiao_psd_codes:this.clueForm,
                    fayuan_psd_codes:this.courtForm
                }
                saveClueMaterial(data).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        created() {
            this.upload_data.case_id=this.$route.query.id
            this.court_data.case_id=this.$route.query.id
            setTimeout(()=>{
                if (this.showList.data.cailiao_list!=''&&this.showList.data.cailiao_list!=undefined){
                    this.application=this.showList.data.cailiao_list
                    //将线索材料psd_code存到数组中方便后边删除数据或者添加数据
                    let cailiao=this.showList.data.cailiao_list
                    let cailiaoArr=cailiao.map(res => res.psd_code);
                    this.clueForm=cailiaoArr
                }
                if (this.showList.data.fayuan_list!=''&&this.showList.data.fayuan_list!=undefined){
                    this.courtList=this.showList.data.fayuan_list
                    //将法院保全文件的psd_code存到数组中方便后边删除数据或者添加数据
                    let fayuan=this.showList.data.fayuan_list
                    let fayuanArr=fayuan.map(res => res.psd_code);
                    this.courtForm=fayuanArr
                }
            },500)

        }
    };
</script>

<style scoped>
    .title{
        margin: 30px 0px;
        color: #3e62f6;
        display: flex;
        align-items: center;
    }
    .title>p{
        margin-right: 10px;
        width: 5px;
        height: 18px;
        background-color: #3e62f6;
    }
    .matter{
        display: flex;
        align-items: center;
        margin: 10px 25px;
    }
    .custom{
        background-color: #3f5cf7;
        color: #fff;
    }
    /deep/.el-input__inner{
        color: #878889 !important;
    }
    /deep/.el-form-item__content{
        height: 32px;
        align-items: center;
    }
    /deep/.el-form-item__content{
        display: flex;
    }
    /deep/.el-input--small,
    /deep/.el-input__inner{
        width: 250px;
    }
    .inline{
        /*width: 50%;*/
        height: 32px;
        margin: 0px 15px;
        display: flex;
        align-items: center;
    }
    /deep/.el-upload--text{
        margin: 0px 20px;
        width: 60px;
        line-height: 30px;
        height: 100%;
        border: 0px;
        color: #fff;
    }
    .preserve{
        width: 100%;
        text-align: center;
    }
    .preserve>button{
        background-color: #3e62f6;
        color: #ffffff;
    }
    .fileContent>p{
        width: 120px;
    }
    /deep/.el-upload-list{
        display: flex;
        align-items: flex-end;
    }
</style>
